import styles from "../../../styles/Components/new-dashboard/DashboardLoaders.module.css";
import { Skeleton } from "antd";

function MarketOverviewLoader() {
  return (
    <>
      <div className={styles.tabsLoader}>
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton.Button shape="round" active key={i} />
        ))}
      </div>
      <div className={styles.newsLoader}>
        <Skeleton active paragraph={{ rows: 3 }} />
      </div>
      <Skeleton.Node className={styles.sentimentLoader} active />
    </>
  );
}

export default MarketOverviewLoader;
